export default {
  en: {
    name: 'English',
    fallbackLocale: 'en',
  },
  en_US: {
    name: 'English (United States)',
    fallbackLocale: 'en',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/available_locales.js